import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cancelFunctions } from 'utils/cancelFunctions';
import { fetchDirectSalesProductList } from 'modules/api/directSalesProductTemplate';
import { changeProductList } from 'store/userOptions/reducer';
import { getMarketId } from 'store/publisher/selectors';
import { transformProductList } from './utils';

const useGetProductTemplates = (): void => {
  const marketId = useSelector(getMarketId);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchProductList = async (): Promise<void> => {
      try {
        const response = await fetchDirectSalesProductList(marketId, cancelFunctions);
        const transformedProducts = transformProductList(response);

        dispatch(changeProductList(transformedProducts));
        // eslint-disable-next-line no-empty
      } catch {}
    };

    fetchProductList();
  }, [marketId]);
};

export default useGetProductTemplates;
